import { SignInForm } from "@/components";
import { Helmet } from "react-helmet-async";
import PageTitle from "@/components/ui/page-title";

const SignInPage = () => {
  return (
    <>
      <Helmet>
        <title>Entrar - MoovaTV</title>
        <meta name="description" content="Entre na sua conta MoovaTV." />
      </Helmet>

      <div className="flex flex-col items-center justify-center min-h-screen">
        <PageTitle className="mb-8">Entrar no</PageTitle>
        <SignInForm />
      </div>
    </>
  );
};

export default SignInPage;
